import PostponedInfo from '@root/bet_utils/PostponedInfo'

// just an alias here, so the comp can also be used from rails views with 'react_component(...)'
export default PostponedInfo
